(function () {
  'use strict';

  function getAssistant() {
    return document.querySelector('[data-vooro-v4]');
  }

  function setMainTab(root, name) {
    root.querySelectorAll('[data-vooro-v4-tab]').forEach(function (button) {
      var active = button.getAttribute('data-vooro-v4-tab') === name;

      button.classList.toggle('is-active', active);
      button.setAttribute(
        'aria-selected',
        active ? 'true' : 'false'
      );
    });

    root.querySelectorAll('[data-vooro-v4-panel]').forEach(function (panel) {
      panel.hidden =
        panel.getAttribute('data-vooro-v4-panel') !== name;
    });

    var body = root.querySelector('.vooro-v4__body');

    if (body) {
      body.scrollTop = 0;
    }
  }

  function setSizeTab(root, name) {
    root.querySelectorAll('[data-vooro-v4-size]').forEach(function (button) {
      var active =
        button.getAttribute('data-vooro-v4-size') === name;

      button.classList.toggle('is-active', active);
      button.setAttribute(
        'aria-selected',
        active ? 'true' : 'false'
      );
    });

    root
      .querySelectorAll('[data-vooro-v4-size-panel]')
      .forEach(function (panel) {
        panel.hidden =
          panel.getAttribute('data-vooro-v4-size-panel') !== name;
      });
  }

  function openAssistant(root, trigger) {
    if (!root) {
      return;
    }

    root._vooroLastFocus =
      trigger || document.activeElement;

    root.hidden = false;

    setMainTab(root, 'size');

    setSizeTab(
      root,
      root.getAttribute('data-default-size') || 'women'
    );

    window.requestAnimationFrame(function () {
      root.classList.add('is-open');
      document.body.classList.add('vooro-v4-open');

      var panel = root.querySelector('.vooro-v4__panel');

      if (panel) {
        panel.focus();
      }
    });
  }

  function closeAssistant(root) {
    if (!root) {
      return;
    }

    root.classList.remove('is-open');
    document.body.classList.remove('vooro-v4-open');

    window.setTimeout(function () {
      root.hidden = true;

      if (
        root._vooroLastFocus &&
        typeof root._vooroLastFocus.focus === 'function'
      ) {
        root._vooroLastFocus.focus();
      }
    }, 280);
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest(
      '[data-vooro-assistant-open], [data-vooro-v4-open]'
    );

    if (openButton) {
      event.preventDefault();
      event.stopPropagation();

      var root = getAssistant();

      if (root) {
        openAssistant(root, openButton);
      } else {
        console.error(
          'VOORO Assistant wurde nicht gefunden. Prüfe den Render-Aufruf.'
        );
      }

      return;
    }

    var closeButton = event.target.closest(
      '[data-vooro-v4-close]'
    );

    if (closeButton) {
      event.preventDefault();

      closeAssistant(
        closeButton.closest('[data-vooro-v4]')
      );

      return;
    }

    var mainTab = event.target.closest(
      '[data-vooro-v4-tab]'
    );

    if (mainTab) {
      setMainTab(
        mainTab.closest('[data-vooro-v4]'),
        mainTab.getAttribute('data-vooro-v4-tab')
      );

      return;
    }

    var sizeTab = event.target.closest(
      '[data-vooro-v4-size]'
    );

    if (sizeTab) {
      setSizeTab(
        sizeTab.closest('[data-vooro-v4]'),
        sizeTab.getAttribute('data-vooro-v4-size')
      );
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    var root = getAssistant();

    if (root && !root.hidden) {
      closeAssistant(root);
    }
  });
})();